import { render } from "./CourseLessonDetailPage.vue?vue&type=template&id=005c8d94&scoped=true"
import script from "./CourseLessonDetailPage.vue?vue&type=script&lang=js"
export * from "./CourseLessonDetailPage.vue?vue&type=script&lang=js"

import "./CourseLessonDetailPage.vue?vue&type=style&index=0&id=005c8d94&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-005c8d94"]])

export default __exports__